module.exports = __webpack_public_path__ + "assets_1789888786567/img/logo_v1.dc05f9dd.png";